<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100006"
      :inFast="Boolean(id)"
    />
  </section>
</template>
<script>
import {
  getVehicleApplyRecord, // 获取详情
} from 'api/car';
// import {
//   getFileUrl,
// } from 'api';
import ApproveBox from 'components/approveBox';
import formInit from './formInit';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      title: '申请转移',
      loading: false,
      detailData: {
      },
    };
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/archives/invited/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleApplyRecord({
        applyRecordId: this.id || this.$route.query.id,
        recordType: 1,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.detailData = formInit;
        this.showDetailItem(detailRes);

        this.detailData.base.tableData.data = detailRes;
        this.detailData.fleet.tableData.data = detailRes;
        this.detailData.applyInfo.tableData.data = detailRes;
        if (this.detailData.approve) {
          this.detailData.approve.tableData.data = detailRes;
        }
      }
    },
    // 【查看】的时候需要显示的信息
    showDetailItem (detailRes) {
      if (detailRes.licenceType === 1) {
        detailRes.vehicleStatusInfo = detailRes.vehicleStatusName + '/' + detailRes.vehicleLengthName;
        this.detailData.base.tableData.title.push([
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'vehicleStatusInfo',
            label: '车辆类型',
          },
          {
            prop: 'vehicleLoad',
            label: '车辆载重（吨）',
          },
          {
            prop: 'lightGoodsSquare',
            label: '车辆容积（立方米）',
          },
        ]);
      }
      if (detailRes.applyVehicleClass === 1 || detailRes.applyVehicleClass === 4) {
        this.detailData.applyInfo = {
          label: '邀请转移自有车司机',
          tableData: {
            title: [
              {
                prop: 'applyRemark',
                label: '申请说明',
              },
              {
                prop: 'drivingLicense',
                label: '行驶证',
                type: 'img',
              },
            ],
            data: {},
            approveData: {},
          },
        };
      } else {
        this.detailData.applyInfo = {
          label: '邀请成为招商车/外调车',
          tableData: {
            title: [
              {
                prop: 'applyRemark',
                label: '邀请说明',
              },
              {
                prop: 'applyFileId',
                label: '附件',
                type: 'img',
              },
            ],
            data: {},
            approveData: {},
          },
        };
      }
      if (this.$route.query.type !== 'detail') {
        // 查看详情才显示审核结果，其他情况不显示
        delete this.detailData.approve;
      }
    },
  },
  mounted () {
    this.getData();
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
};
</script>
<style>
</style>
